import { Component, OnInit, Input, EventEmitter, Output, SimpleChanges, OnChanges } from '@angular/core';
import { NgSelectComponent } from '@ng-select/ng-select'
import { I18NextPipe } from 'angular-i18next';
@Component({
    selector: 'app-widget-report-columns-select',
    templateUrl: './widget-report-columns-select.component.html',
    styleUrls: ['./widget-report-columns-select.component.scss'],
    standalone: false
})
export class WidgetReportColumnsSelectComponent implements OnInit, OnChanges {

  @Input() items: Array<any>=[];
  @Input() bindLabel: string;
  @Input() bindValue: string;
  @Input() placeholder: string = "Select";
  @Input() translateItems: boolean = false;
  @Input() model: any=[];
  @Input() defaultColumns: string[];
  @Input() disabledColumns: string[];
  @Output() modelChange = new EventEmitter<any>();
  @Input() title: string;
  isOpen: boolean;
  restrictedItems: any;
  keyItems: any;
  keyCount:number = 0;
  isFiltered: boolean = false;
  filteredItems: Array<any>;

  constructor( private i18nextPipe: I18NextPipe) { }
  get isAllItemsSelected(): boolean {
    return this.items?.length+this.restrictedItems?.length==this.model?.length;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.items && this.model) {
      let itemIds = this.items.map((i) => i[this.bindValue]);
      this.keyItems = this.items.filter((i) => i.isKey);
      this.restrictedItems = this.model.filter((v) => { return !itemIds.includes(v); });
    }

    if (changes.items && changes.items.currentValue.length > 0) {
      // this logic is duplicated in the BE in method EnrichColumnsList
      let filteredItems = this.items.filter(i =>
        (i.isKey || this.defaultColumns.includes(i.labelCode)) &&
        (this.model || []).indexOf(i[this.bindValue]) < 0);

      let mappedItems = filteredItems.map((i) => i[this.bindValue]);
      this.model = [...mappedItems || [], ...this.model || []];
      // end of duplicated logic
      this.items = this.items.map(i => ({ ...i, disabled: i.isKey || this.disabledColumns?.includes(i.labelCode) }));
      this.keyCount = this.items.filter(i => i.isKey).length;
      this.modelChange.emit(this.model);
    }

    if (changes.disabledColumns) {
      this.items = this.items?.map(i => ({ ...i, disabled: i.isKey || this.disabledColumns?.includes(i.labelCode) }));
    }
  }

  ngOnInit(): void { }

  get isAllFilteredItemsSelected(): boolean {
    return this.isFiltered && this.filteredItems?.every(i => this.model?.indexOf(i[this.bindValue]) > -1);
  }

  onSearch($event){
     this.isFiltered=$event.term.length>0;
     this.filteredItems=$event.items;
  }

  selectAll(ngSelectControl: NgSelectComponent) {
    let model = [...this.model ?? []];
    if (this.isFiltered && !this.isAllFilteredItemsSelected) {
      this.filteredItems?.forEach(element => {
        if (model.indexOf(element[this.bindValue]) == -1) {
          model.push(element[this.bindValue]);
        }
      });
    } else if (this.isFiltered && this.isAllFilteredItemsSelected) {
      this.filteredItems?.forEach(element => {
        let index = model.indexOf(element[this.bindValue]);
        if (index > -1) {
          model.splice(index, 1);
        }
      });
    } else if (!this.isAllItemsSelected) {
      model = this.items.map(p => p[this.bindValue]);
    }
    else {
      model = [];
      this.restrictedItems?.forEach(element => {
        model.push(element);
      });
      this.keyItems?.forEach(element => {
        model.push(element[this.bindValue])
      });
    }
    this.model = model;
    this.modelChange.emit(this.model);
  }

  itemText(id: number) {
    let item = this.items?.find((i) => i[this.bindValue] == id)
    return item ? item[this.bindLabel] : '';
  }
  isItemDisabled(id: number) {
    let item = this.items?.find((i) => i[this.bindValue] == id)
    return item && item.disabled;
  }
  itemExists(id: number) {
    return this.items?.find((i) => i[this.bindValue] == id) != undefined;
  }
  clearItem(ngSelectControl: NgSelectComponent, id: number) {
    let item = this.items?.find((i) => i[this.bindValue] == id);
    if(item && item.disabled) return;
    ngSelectControl.clearItem(this.items?.find((i) => i[this.bindValue] == id));
  }

  removeItem(clearFunc,item){
    if(!item.disabled){
          clearFunc(item);
    }
  }


  customSearchFn = (term: string, item: any) => {
    let name = item[this.bindLabel];
    if(this.translateItems){
      name= this.i18nextPipe.transform('dashboard:'+name)
    }
    return name.toLocaleLowerCase().indexOf(term.toLocaleLowerCase()) > -1;
  }
}
